import { CreditViewResult, getCreditMemos, GetCreditMemosApiParameter } from "@dana/Services/CreditService";
import { CreditStateActions } from "@dana/Store/Data/ViewCredit/Reducers/ViewCreditReducer";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { DispatchProp } from "react-redux";


export interface GetCreditMemosParameter extends HasPagingParameters {
    creditMemoNumber?: string;
    primaryPONumber?: string;
    secondaryPoNumber?: string;
    partNumber?: string;  
    creditMemoTotal?: string; 
    fromDate?: string;
    poNumber?: string;
    toDate?: string;
    sortBy?: string;
    orderType?: string;
}

type HandlerType = ApiHandlerDiscreteParameter<
    GetCreditMemosParameter,
    GetCreditMemosApiParameter,
    CreditViewResult,
    DispatchProp<CreditStateActions>
>;

function setUrlSearchParams(params: Record<string, any>) {
    const url = new URL(window.location.href);

    // First, remove keys from searchParams that are not in params
    const currentKeys = Array.from(url.searchParams.keys());
    currentKeys.forEach((key) => {
        if (!(key in params)) {
            url.searchParams.delete(key);
        }
    });

    // Then, update or delete based on param values
    Object.entries(params).forEach(([key, value]) => {
        if (value != null && value !== "") {
            url.searchParams.set(key, value.toString());
        } else {
            url.searchParams.delete(key);
        }
    });
    window.history.replaceState({}, "", url.toString());
}

export const DispatchSetParameters: HandlerType = props => {
    props.dispatch({
        type: "CreditViewState/IsLoading",
        isLoading: true,
    });
};
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.apiParameter,
        ...props.parameter
    };
};

export const RequestDataFromApi: HandlerType = async props => {

    setUrlSearchParams(props.apiParameter)
    props.apiResult = await getCreditMemos(props.apiParameter);
};
export const LoadCreditMemosResponse: HandlerType = props => {
    props.dispatch({
        type: "CreditViewState/LoadCredits",
        allCredits: props.apiResult.allCredits,
        creditMemos: props.apiResult.credits,
        pagination: props.apiResult.pagination,
        creditsCount: props.apiResult.creditsCount,
        appliedCreditAmount: props.apiResult.appliedCreditAmount,
        openCreditAmount: props.apiResult.openCreditAmount,
    });

    props.dispatch({
        type: "CreditViewState/IsLoading",
        isLoading: false,
    });
};

export const chain = [DispatchSetParameters, PopulateApiParameter, RequestDataFromApi, LoadCreditMemosResponse];

const getCreditMomos = createHandlerChainRunner(chain, "GetCreditMomos");
export default getCreditMomos;